import { authAPI } from './api'

class AdminAuthService {
  constructor() {
    this.baseUrl = '/auth'
  }

  /**
   * Admin login with email and password
   */
  async login(credentials) {
    try {
      const response = await authAPI.login({
        email: credentials.email,
        password: credentials.password,
        remember: credentials.remember || false
      })

      return {
        success: true,
        token: response.data.token,
        user: response.data.user,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Giriş başarısız'
      }
    }
  }

  /**
   * Verify current token validity
   */
  async verifyToken() {
    try {
      const response = await authAPI.verifyToken()
      
      return {
        success: true,
        user: response.data.user,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Token geçersiz'
      }
    }
  }

  /**
   * Refresh authentication token
   */
  async refreshToken() {
    try {
      const response = await authAPI.refreshToken()
      
      return {
        success: true,
        token: response.data.token,
        user: response.data.user,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Token yenilenemiyor'
      }
    }
  }

  /**
   * Admin logout
   */
  async logout() {
    try {
      await authAPI.logout()
      return { success: true }
    } catch (error) {
      // Even if logout fails on server, we'll clear local state
      return { success: true }
    }
  }

  /**
   * Get current admin user profile
   */
  async getProfile() {
    try {
      const response = await authAPI.getProfile()
      
      return {
        success: true,
        user: response.data.user
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Profil bilgileri alınamadı'
      }
    }
  }

  /**
   * Update admin user profile
   */
  async updateProfile(profileData) {
    try {
      const response = await apiClient.put(`${this.baseUrl}/profile`, profileData)
      
      return {
        success: true,
        user: response.data.user,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Profil güncellenemedi'
      }
    }
  }

  /**
   * Change admin password
   */
  async changePassword(passwordData) {
    try {
      const response = await apiClient.put(`${this.baseUrl}/password`, {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
        confirmPassword: passwordData.confirmPassword
      })
      
      return {
        success: true,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Şifre değiştirilemedi'
      }
    }
  }

  /**
   * Enable/Disable 2FA
   */
  async toggle2FA(enable = true) {
    try {
      const response = await apiClient.post(`${this.baseUrl}/2fa/toggle`, {
        enable
      })
      
      return {
        success: true,
        qrCode: response.data.qrCode, // For enabling 2FA
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || '2FA ayarı değiştirilemedi'
      }
    }
  }

  /**
   * Verify 2FA code
   */
  async verify2FA(code) {
    try {
      const response = await apiClient.post(`${this.baseUrl}/2fa/verify`, {
        code
      })
      
      return {
        success: true,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || '2FA kodu geçersiz'
      }
    }
  }

  /**
   * Get admin session history
   */
  async getSessionHistory(page = 1, limit = 10) {
    try {
      const response = await apiClient.get(`${this.baseUrl}/sessions`, {
        params: { page, limit }
      })
      
      return {
        success: true,
        sessions: response.data.sessions,
        pagination: response.data.pagination
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Oturum geçmişi alınamadı'
      }
    }
  }

  /**
   * Request password reset
   */
  async requestPasswordReset(email) {
    try {
      const response = await apiClient.post(`${this.baseUrl}/password-reset/request`, {
        email
      })
      
      return {
        success: true,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Şifre sıfırlama isteği gönderilemedi'
      }
    }
  }

  /**
   * Reset password with token
   */
  async resetPassword(token, newPassword) {
    try {
      const response = await apiClient.post(`${this.baseUrl}/password-reset/confirm`, {
        token,
        newPassword
      })
      
      return {
        success: true,
        message: response.data.message
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Şifre sıfırlanamadı'
      }
    }
  }
}

export const adminAuthService = new AdminAuthService()
export default adminAuthService